import { render, staticRenderFns } from "./template_list.vue?vue&type=template&id=471501d7&scoped=true"
import script from "./template_list.vue?vue&type=script&lang=js"
export * from "./template_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471501d7",
  null
  
)

export default component.exports